import multiFilePathDialogTemplate from './multi-file-path-dialog.tpl.html';
import './multi-file-path-dialog.less';
import { modalComponentModule } from '../modal/modal';
import { cleanPath } from '../../utils/file-utils/file-utils';

export const multiFilePathDialogComponentModule = angular
  .module('Q.components.multi-file-path-dialog', [modalComponentModule])

  .factory('multiFilePathDialog', function ($modal) {
    return {
      /**
       *
       * @param params.path {String?} Initial path (blank)
       * @param params.title {String?} Dialog title
       * @param params.prompt {String?} Prompt for input
       * @param params.placeholder {String?} placeholder for input
       * @param params.isReference {boolean?} true if this is a reference file or directory
       * @param params.hasReference {boolean?} true if this file has a reference file that should be renamed
       * @param params.allowRoot {boolean?} true if we can return an empty string (root)
       * @param params.examples {Array<string>?} if provided, shown as an example of the final path for multiple file imports
       * @param params.moreFiles {Number?} shows there there's more files than the examples
       * @param params.directory {boolean?} true if this is a directory
       * @param params.showDirectoryToggle {boolean?} true if we want to let the user change the directory mode
       * @param params.invalid {Function?} Optional validation method, which needs to return `false` or a message to show if invalid
       * @param params.warning (Function?} Optional method which returns a warning if necessary
       * @returns {Promise} With the resulting path
       */
      open: (params) => {
        return $modal.openOnce('multiFilePathDialog', {
          template: multiFilePathDialogTemplate,
          controller: 'MultiFilePathDialogCtrl as $ctrl',
          windowClass: 'multi-file-path-dialog',
          size: 'md',
          resolve: {
            params: () => params,
          },
        }).result;
      },
    };
  })

  .controller(
    'MultiFilePathDialogCtrl',
    function MultiFilePathDialogCtrl($modalInstance, $scope, params) {
      const {
        path = '',
        directory = false,
        showDirectoryToggle = false,
        isReference = false,
        showReferenceChoice = false,
        hasReference = false,
        allowRoot = false,
        accessLevels = false,
        title = 'Add File',
        prompt = 'New file path & name:',
        placeholder = 'src/lib/util.js',
        examples,
        moreFiles,
        invalid = () => false,
        warning = () => false,
      } = params;

      const ctrl = this;
      ctrl.disabled = false;

      ctrl.path = path;
      ctrl.examples = examples;
      ctrl.moreFiles = moreFiles;

      ctrl.directory = directory;
      ctrl.showDirectoryToggle = showDirectoryToggle;
      ctrl.isReference = ctrl.reference = isReference; // ctrl.reference is for icon styling
      ctrl.showReferenceChoice = showReferenceChoice;
      ctrl.extractReference = hasReference;
      ctrl.hasReference = hasReference;
      ctrl.renameReference = true;
      ctrl.allowRoot = allowRoot;

      ctrl.accessLevels = accessLevels;
      ctrl.accessLevel = accessLevels && accessLevels[0].value;

      ctrl.title = title;
      ctrl.prompt = prompt;
      ctrl.placeholder = placeholder;

      ctrl.onPathChanged = () => {
        if (showDirectoryToggle && ctrl.path && !ctrl.directoryManualToggled) {
          // unless manually set, swap directory state automatically if the path ends with `/`
          ctrl.directory = ctrl.path.endsWith('/');
        }
        const cleanedPath = cleanPath(ctrl.path);
        ctrl.cleanPath = cleanedPath ? '/' + cleanedPath : '';
        ctrl.warningMessage = warning(cleanedPath, ctrl);
      };

      ctrl.cancel = () => $modalInstance.dismiss('cancel');

      ctrl.pathIsInvalid = (path = ctrl.path) => {
        ctrl.invalidMessage = invalid(cleanPath(path), ctrl.renameReference);
        ctrl.icon = ctrl.cleanPath && ctrl.invalidMessage ? 'warning' : null;
        return ctrl.invalidMessage;
      };

      ctrl.focusInput = () => {
        const input = $modalInstance
          .getElement()
          .querySelector('input[name="multiFilePathInput"]');
        input && input.focus();
      };

      ctrl.add = () => {
        ctrl.path = cleanPath(ctrl.path);
        if (!ctrl.pathIsInvalid()) {
          $modalInstance.close(ctrl);
        }
      };
    },
  )

  .directive('multiFilePathInput', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link(scope, elem, attr, ngModelCtrl) {
        ngModelCtrl.$validators.filePath = (modelValue) => {
          return !modelValue || !scope.$ctrl.pathIsInvalid(modelValue);
        };
        scope.$applyAsync(() => {
          let start = elem.val().lastIndexOf('/') + 1;
          elem.focus().selectInput(start);
        });
      },
    };
  });
